/* RareDude shared product card behaviour: dots follow swipe + "+" adds to cart and opens the existing cart drawer */
(function(){
  if(window.__rdCardInit) return; window.__rdCardInit = true;

  /* dots follow the swipe track */
  document.addEventListener('scroll', function(e){
    var t = e.target;
    if(!t || !t.classList || !t.classList.contains('rdc-track')) return;
    var dots = t.parentNode.querySelectorAll('.rdc-dot');
    if(!dots.length) return;
    var i = Math.round(t.scrollLeft / (t.clientWidth || 1));
    for(var d=0; d<dots.length; d++) dots[d].classList.toggle('is-active', d===i);
  }, true);

  var PLUS = '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';

  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('[data-rdc-add]') : null;
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var vid = btn.getAttribute('data-variant-id');
    if(!vid || btn.disabled || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: parseInt(vid,10), quantity: 1 })
    })
    .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function(){
      btn.classList.remove('is-loading'); btn.classList.add('is-done'); btn.innerHTML = TICK;
      return fetch('/cart.js').then(function(r){ return r.json(); });
    })
    .then(function(cart){
      /* same events the previous + buttons fired, so the cart drawer opens/refreshes exactly as before */
      document.querySelectorAll('cart-count,.cart-count,[data-cart-count],.header__cart-count,.cart-item-count').forEach(function(el){
        el.textContent = cart.item_count; if(cart.item_count>0) el.removeAttribute('hidden');
      });
      window.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart:cart}}));
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart:cart}}));
      window.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));
    })
    .catch(function(){ btn.classList.remove('is-loading'); })
    .then(function(){ setTimeout(function(){ btn.classList.remove('is-done','is-loading'); btn.innerHTML = PLUS; }, 1800); });
  });
})();

/* "Load more" for collection grids — builds the exact same card markup as snippets/rd-card.liquid */
(function(){
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }
  var fmt = (window.theme && theme.settings && theme.settings.moneyFormat || '')
    .replace(/\{\{\s*amount(_with_(?:comma|space|apostrophe)_separator)?\s*\}\}/, function(m,sep){ return '{'+'{amount_no_decimals'+(sep||'')+'}'+'}'; });
  function money(v){
    var n = Number(v)||0, cents = Math.round(n*100);
    try{ return window.theme.Currency.formatMoney(cents, fmt); }catch(e){ return '\u20B9'+n.toLocaleString('en-IN'); }
  }
  function card(p, max){
    var v = p.variants && p.variants[0] || {}, url = '/products/'+p.handle, imgs = (p.images||[]).slice(0,max);
    var slides = imgs.length ? imgs.map(function(im,i){
      return '<a class="rdc-slide" href="'+url+'" aria-label="'+esc(p.title)+'"><img src="'+esc(im.src)+'" alt="'+esc(im.alt||p.title)+'" width="600" height="'+Math.round(600*(im.height||1)/(im.width||1))+'" loading="lazy" decoding="async"></a>';
    }).join('') : '<a class="rdc-slide" href="'+url+'"></a>';
    var dots = imgs.length>1 ? '<div class="rdc-dots" aria-hidden="true">'+imgs.map(function(_,i){return '<span class="rdc-dot'+(i===0?' is-active':'')+'"></span>';}).join('')+'</div>' : '';
    var was = (parseFloat(v.compare_at_price)>parseFloat(v.price)) ? '<s>'+money(v.compare_at_price)+'</s>' : '';
    var soldOut = p.variants && !p.variants.some(function(x){return x.available;});
    return '<div class="rdc-card" data-product-id="'+p.id+'"><div class="rdc-media"><div class="rdc-track">'+slides+'</div>'+(soldOut?'<span class="rdc-badge">Sold out</span>':'')+dots+'</div>'
      + '<div class="rdc-info"><div class="rdc-text"><h3 class="rdc-title"><a href="'+url+'">'+esc(p.title)+'</a></h3><p class="rdc-price">'+money(v.price)+was+'</p></div>'
      + '<button type="button" class="rdc-add" data-rdc-add data-variant-id="'+v.id+'" aria-label="Add '+esc(p.title)+' to cart"'+(v.available===false?' disabled':'')+'><svg viewBox="0 0 24 24" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button></div></div>';
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('[data-rdc-more]') : null;
    if(!btn || btn.disabled) return;
    var grid = document.querySelector(btn.getAttribute('data-grid')); if(!grid) return;
    var per = parseInt(btn.dataset.perPage,10), page = parseInt(btn.dataset.page,10)+1, total = parseInt(btn.dataset.total,10), max = parseInt(btn.dataset.maxImages,10)||3;
    btn.disabled = true; btn.textContent = 'Loading...';
    fetch('/collections/'+btn.dataset.collection+'/products.json?limit='+per+'&page='+page)
      .then(function(r){ return r.json(); })
      .then(function(d){
        var list = d.products||[]; grid.insertAdjacentHTML('beforeend', list.map(function(p){return card(p,max);}).join(''));
        btn.dataset.page = page;
        if(page*per >= total || list.length < per){ var w = btn.closest('.rdc-more-wrap'); (w||btn).remove(); }
        else { btn.disabled = false; btn.textContent = 'Load more'; }
      })
      .catch(function(){ btn.disabled = false; btn.textContent = 'Load more'; });
  });
})();
